module.exports = __webpack_public_path__ + "~@/assets/img/dimas.1ecdbf01.png";